<template>
  <div class="mt-0 pt-0">
    <v-card class="elevation-2" outlined>
      <v-card-title class="d-flex flex-wrap align-center" style="gap: 12px;">
        <div>
          <div class="text-h6">Aceptacion de terminos y condiciones.</div>
          <div class="text-body-2 text--secondary">
            Opciones de filtros
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-chip color="green lighten-4" class="green--text text--darken-4" small>
          Aceptaron: {{ totalAceptadasEnRango }}
        </v-chip>
        <v-chip color="blue-grey lighten-5" class="blue-grey--text text--darken-3" small>
          Inscripciones: {{ inscripciones.length }}
        </v-chip>
      </v-card-title>

      <v-card-text class="pt-2">
        <v-row dense class="mb-0"> 
          <v-col cols="12" md="2">
            <v-text-field
              v-model="fechaInicio"
              dense
              outlined
              type="date"
              label="Inscripciones desde:"
              hide-details
            />
          </v-col>
          <v-col cols="12" md="2">
            <v-text-field
              v-model="fechaFin"
              dense
              outlined
              type="date"
              label="Inscripciones hasta:"
              hide-details
            />
          </v-col>
          <v-col cols="12" md="4">
            <v-combobox 
              v-model="sedeSeleccionada" 
              :items="$store.state.CARGOS"  
              item-text="nombre" 
              hide-details
              outlined
              dense
              label="Sede de programas"
              :clearable="ver_todas_las_sedes"
            ></v-combobox> 

            <!-- <multiselect 
              v-model="sedeSeleccionada" 
              :options="$store.state.CARGOS"  
              :disabled="!$store.state.show_rol_select"
              track-by="idsede" 
              label="nombre" 
              class="form-control mt-1 ml-1" 
              :searchable="true" 
              :close-on-select="true" 
              :show-labels="false" 
              :multiple="false" 
              clearable 
              placeholder="sede de programas..." /> -->
          </v-col>
          <v-col cols="12" md="4">
            <v-combobox 
              v-model="asesor" 
              :items="asesores" 
              :loading="isLoadingAsesores"
              :disabled="!ver_todo"
              hide-details
              outlined
              dense
              label="Asesor"
              clearable
            ></v-combobox>
          </v-col>
        </v-row>

        <v-row dense> 
          <v-col cols="12" md="4">
            <v-text-field
              v-model="search"
              dense
              outlined
              clearable
              prepend-inner-icon="mdi-magnify"
              label="Buscar contacto"
              hide-details
            />
          </v-col>
        </v-row>
        
        <v-chip v-if="terminos" color="blue lighten-5" class="blue--text text--darken-3" small>
          {{ terminos.title || 'Terminos' }} - {{ terminos.version_code || 'S/V' }}
        </v-chip>
        
        <v-row dense class="mb-2">
          <v-col cols="12" md="4">
            
            <v-btn color="green" dark depressed :loading="loading" @click="listar_registros">
              <v-icon left>mdi-refresh</v-icon>
              Actualizar
            </v-btn>
            <v-btn
              color="blue-grey"
              dark
              depressed
              :disabled="loading || !inscripcionesFiltradas.length"
              @click="descargarCSV"
            >
              <v-icon left>mdi-file-delimited</v-icon>
              CSV
            </v-btn>
          </v-col>
        </v-row>

        <v-alert v-if="msg" dense outlined type="warning" class="mb-3">
          {{ msg }}
        </v-alert>

        <v-data-table
          :headers="headers"
          :items="inscripcionesFiltradas"
          :loading="loading"
          :items-per-page="25"
          dense
          class="elevation-1"
          loading-text="Cargando inscripciones..."
          no-data-text="No hay inscripciones para mostrar"
        >
          <template v-slot:loading>
            <v-skeleton-loader type="table" />
          </template>

          <template v-slot:[`item.estudiante_nombre`]="{ item }">
            {{ item.estudiante_nombre || '-' }}
          </template>

          <template v-slot:[`item.programa_nombre`]="{ item }">
            <span style="min-width: 300px;display: block;"> {{ item.programa_nombre || '-' }} </span>
          </template>

          <template v-slot:[`item.sede_nombre`]="{ item }">
            {{ item.sede_nombre || '-' }}
          </template>

          <template v-slot:[`item.fecha_inscripcion`]="{ item }">
            {{ parseFecha(item.fecha_inscripcion) }}
          </template>

          <template v-slot:[`item.asesor_nombre`]="{ item }">
            {{ item.asesor_nombre || '-' }}
          </template>

          <template v-slot:[`item.acepto_terminos`]="{ item }">
            <v-chip :color="item.estado_encolado != null ? 'green lighten-4' : 'red lighten-4'" small>
              <span :class="item.estado_encolado != null ? 'green--text text--darken-4' : 'red--text text--darken-4'">
                {{ item.fecha_aceptacion_terminos != null ? 'Aceptó' : 'No aceptó' }}
              </span>
            </v-chip>
            <span> {{ item.fecha_aceptacion_terminos ? parseFecha(item.fecha_aceptacion_terminos) : '' }} </span>
          </template> 

          <template v-slot:[`item.correo_enviado`]="{ item }">
            <v-chip :color="item.correo != null ? 'green lighten-4' : 'red lighten-4'" small>
              <span :class="item.correo != null ? 'green--text text--darken-4' : 'red--text text--darken-4'">
                {{ item.correo != null ? 'Sí' : 'No' }}
              </span>
            </v-chip>
            {{ item.correo_enviado_el ? parseFecha(item.correo_enviado_el) : '' }}
            <small> {{ item.correo }} </small>
          </template> 
        </v-data-table>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import gql from 'graphql-tag';
import { terminos_condiciones, terminos_aceptaciones_porv2, ver_todos_asesores, ver_todas_sedes } from './utils';

  export default {
    data() {
      return {
        loading: false,
        isLoadingAsesores: false,
        msg: '',
        search: '',
        fechaInicio: '',
        fechaFin: '',
        sedeSeleccionada: null,
        asesor: null,
        asesores: [],
        terminos: null,
        inscripciones: [],
        ver_todo: ver_todos_asesores(this),
        ver_todas_las_sedes: ver_todas_sedes(this),
        headers: [
          { text: 'Fecha inscripción', value: 'fecha_inscripcion', width: 110 },
          { text: 'Estudiante', value: 'estudiante_nombre',width: 180 },
          { text: 'Programa', value: 'programa_nombre', width: 260 },
          { text: 'Sede', value: 'sede_nombre', width: 100 },
          { text: 'Asesor', value: 'asesor_nombre', width: 180 },
          { text: 'Correo enviado', value: 'correo_enviado', width: 130 },
          { text: 'Términos', value: 'acepto_terminos', width: 130 },
          // { text: 'Fecha aceptación', value: 'fecha_aceptacion_terminos', width: 150 },
          // { text: 'Fecha correo', value: 'correo_enviado_el', width: 150 },
        ],
      };
    },
    computed: {
      unidadNegocioId() {
        return this.$store.state.CARGO && this.$store.state.CARGO.sede
          ? this.$store.state.CARGO.sede.unidad_negocio
          : null;
      },
      totalAceptadasEnRango() {
        return this.inscripciones.filter((item) => item.estado_encolado != null).length;
      },
      inscripcionesFiltradas() {
        if (!this.search) return this.inscripciones;
        const q = this.search.toLowerCase();
        return this.inscripciones.filter((item) => {
          return [
            item.inscripcion_id,
            item.fecha_inscripcion,
            item.estudiante_nombre,
            item.programa_nombre,
            item.sede_nombre,
            item.asesor_nombre,
            item.fecha_aceptacion_terminos,
            item.estado_encolado != null ? 'acepto aceptó si' : 'no acepto aceptó',
            item.correo != null ? 'correo enviado si' : 'correo no enviado',
            item.correo,
            item.correo_enviado_el,
          ].some((value) => String(value || '').toLowerCase().includes(q));
        });
      },
    },
    watch: {
      '$store.state.CARGO': function() {
        this.listar_registros();
      },
      sedeSeleccionada: function() {
        this.listar_asesores();
      },
    },
    methods: {
      async listar_terminos(){
        if (!this.unidadNegocioId) return;
        const q = {
          unidad_negocio: this.unidadNegocioId,
        };
        let terminos = await terminos_condiciones(q);
        if (terminos && terminos.length > 0) terminos = terminos[0];

        this.terminos = terminos || null;

        if (!this.terminos || !this.terminos.id) {
          this.msg = 'No se encontraron terminos para la unidad de negocio actual';
          return;
        }
      },
      async listar_registros() { 
        this.loading = true;
        this.msg = '';
        this.inscripciones = [];

        try {
          
          const qu = {
            desde: this.fechaInicio+'T00:00:00',
            hasta: this.fechaFin+'T23:59:59',
            // terminos_id: this.terminos.id,
          }
          if(this.sedeSeleccionada){
            qu.sede_id = this.sedeSeleccionada.idsede;
          }
          if(this.asesor){
            qu.asesor_id = this.asesor.id;
          }

          const res = await terminos_aceptaciones_porv2(qu);
          const unidades = [1,5,10]

          this.inscripciones = Array.isArray(res) ? res.filter(x=>unidades.includes(x.unidad_negocio_id)) : [];
        } catch (e) {
          window.console.error(e);
          this.msg = 'No se pudo cargar la lista de inscripciones y aceptaciones';
        } finally {
          this.loading = false;
        }
      },
      setFechasDefault() {
        const fin = new Date();
        const inicio = new Date();
        inicio.setDate(inicio.getDate() - 30);
        this.fechaInicio = this.formatoFechaInput(inicio);
        this.fechaFin = this.formatoFechaInput(fin);
      },
      habilitarcampos(){
        if(!this.ver_todo || !this.ver_todas_las_sedes){
          const sede = this.$store.state.CARGOS[0]
          this.sedeSeleccionada = sede;
        }
      },
      formatoFechaInput(date) {
        const yyyy = date.getFullYear();
        const mm = String(date.getMonth() + 1).padStart(2, '0');
        const dd = String(date.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      },
      descargarCSV() {
        const headers = [
          'inscripcion_id',
          'fecha_inscripcion',
          'estudiante',
          'programa',
          'sede',
          'asesor',
          'terminos',
          'fecha_aceptacion',
          'correo_enviado',
          'fecha_correo_enviado',
          'correo',
        ];
        const rows = this.inscripcionesFiltradas.map((item) => {
          return [
            item.inscripcion_id,
            this.parseFecha(item.fecha_inscripcion),
            item.estudiante_nombre || '',
            item.programa_nombre || '',
            item.sede_nombre || '',
            item.asesor_nombre || '',
            item.estado_encolado != null ? 'Acepto' : 'No acepto',
            item.fecha_aceptacion_terminos ? this.parseFecha(item.fecha_aceptacion_terminos) : '',
            item.correo != null ? 'Si' : 'No',
            item.correo_enviado_el ? this.parseFecha(item.correo_enviado_el) : '',
            item.correo || '',
          ];
        });
        const csv = [headers, ...rows].map((row) => row.map(this.valorCSV).join(',')).join('\n');
        const blob = new Blob([`\ufeff${csv}`], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = `terminos-inscripciones-${this.fechaInicio}-${this.fechaFin}.csv`;
        link.click();
        URL.revokeObjectURL(link.href);
      },
      valorCSV(value) {
        const text = String(value == null ? '' : value);
        return `"${text.replace(/"/g, '""')}"`;
      },
      parseFecha(f) {
        if (!f) return '';
        const fs = f.split(/[T ]/)[0].split('-');
        if (fs.length !== 3) return f;
        return `${fs[2]}/${fs[1]}/${fs[0]}`;
      },
      async listar_asesores(){
        this.asesores = []
        this.asesor = null
        if(!this.sedeSeleccionada) return;

        this.isLoadingAsesores = true;
        const sql = gql`query{ getSede(id:${this.sedeSeleccionada.idsede}){usuarios_activos{usuario{estado,datos_personales{id,nombres,pri_apellido,seg_apellido},cargos{cargo{id,nombre}},}}} }`;
        const data = await this.$apollo.query({ query: sql }).then((data) => data).catch((error) => error);
        this.isLoadingAsesores = false;
        const sed = data.data.getSede;
        const datas = [];
        if (sed.usuarios_activos == null) return;
        sed.usuarios_activos.forEach(function(e) {
          var dp = e.usuario.datos_personales;
          var seg = dp.seg_apellido == null ? '' : dp.seg_apellido;
          var no = dp.nombres + ' ' + dp.pri_apellido + ' ' + seg;
          let text = `${no} (${dp.id}) `;
          if (e.usuario.estado && e.usuario.datos_personales.id != 2)
            datas.push({ id: dp.id, nombres: no, text: text });
        });
        this.asesores = datas

        if(!this.ver_todo) {
          const id = this.$store.state.DATA_USER.id
          const ase = this.asesores.find(x=>x.id == id)
          this.asesor = ase;
          this.listar_registros();
        }

      }
    },
    mounted() {
      this.setFechasDefault();
      this.habilitarcampos();
      this.listar_terminos();
      if(this.ver_todo){
        this.listar_registros();
      }
    },
  };
</script>
